import { Suspense, lazy } from "react";
const InstanceStateVisualizationInner = lazy(() => import("./inner"));

export default function InstanceStateVisualization() {
  return (
    <Suspense fallback={<div className="animate-pulse">Loading...</div>}>
      <InstanceStateVisualizationInner />
    </Suspense>
  );
}
